<template>
  <mail-template-form :edit="true" @updated="backToList" @cancel="backToList" />
</template>

<script>
import MailTemplateForm from '@/components/forms/MailTemplateForm';

// @vuese
// Edycja szablonu wiadomości
// @group MailTemplate
export default {
  components: { MailTemplateForm },
  methods: {
    // @vuese
    // Powraca do listy wiadomości
    backToList() {
      this.$router.push({ name: 'mailTemplates' });
    }
  }
};
</script>
